import { Button, Text, tokens, makeStyles } from "@fluentui/react-components";
import { SignOut24Regular } from "@fluentui/react-icons";
import { useAuth } from "../contexts/AuthContext";
import { getConfig } from "../config";

const useStyles = makeStyles({
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 1.5rem",
    height: "48px",
    background: `linear-gradient(135deg, ${tokens.colorBrandBackground} 0%, ${tokens.colorBrandBackgroundPressed} 100%)`,
    color: tokens.colorNeutralForegroundOnBrand,
    boxShadow: tokens.shadow4,
    flexShrink: 0,
  },
  title: {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
    fontWeight: 700,
    fontSize: "1.1rem",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  envBadgeDev: {
    backgroundColor: tokens.colorPaletteTealBackground2,
    color: tokens.colorPaletteTealForeground2,
    fontWeight: 600,
    fontSize: "0.65rem",
    padding: "2px 6px",
    borderRadius: "4px",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  },
  envBadgeUat: {
    backgroundColor: tokens.colorPaletteMarigoldBackground2,
    color: tokens.colorPaletteMarigoldForeground2,
    fontWeight: 600,
    fontSize: "0.65rem",
    padding: "2px 6px",
    borderRadius: "4px",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  },
  userInfo: {
    display: "flex",
    alignItems: "center",
    gap: "0.75rem",
    flexShrink: 0,
  },
  userName: {
    fontSize: "0.85rem",
    opacity: 0.9,
    "@media (max-width: 480px)": {
      display: "none",
    },
  },
});

export function Header() {
  const { userName, logout } = useAuth();
  const styles = useStyles();
  const config = getConfig();

  // Get environment badge style and label (hidden for prod)
  const getEnvBadge = () => {
    const env = config?.environment;
    if (!env || env === "prod") return null;

    const badgeClass = env === "dev" ? styles.envBadgeDev : styles.envBadgeUat;
    const label = env.toUpperCase();

    return <span className={badgeClass}>{label}</span>;
  };

  return (
    <header className={styles.header}>
      <div className={styles.title}>
        <span role="img" aria-label="robot">
          🤖
        </span>
        <Text weight="bold" style={{ color: "inherit", fontSize: "inherit" }}>
          RFP Assistant
        </Text>
        {getEnvBadge()}
      </div>
      <div className={styles.userInfo}>
        <span className={styles.userName}>{userName || "User"}</span>
        <Button
          appearance="subtle"
          icon={<SignOut24Regular />}
          onClick={logout}
          style={{ color: "inherit" }}
          size="small"
        >
          Sign out
        </Button>
      </div>
    </header>
  );
}
